
import React from 'react';

interface FeatureListProps {
  icon: React.ElementType;
  items: string[];
}

const FeatureList = ({ icon: Icon, items }: FeatureListProps) => {
  return (
    <ul className="space-y-2 text-gray-600">
      {items.map((item, index) => (
        <li key={index} className="flex items-center">
          <Icon className="h-4 w-4 mr-2 text-primary-blue" />
          {item}
        </li>
      ))}
    </ul>
  );
};

export default FeatureList;

